import * as RestaurantPoolScheduleActions  from '../actions/restaurantPoolSchedule'

const initialState = {
  csvParseRaw : null,
  csvParseErrors: [],
  scheduleError:null,
  isLoading: false,
  lastScheduleRowUpdate: null,
  scheduleRows: [],
  invalidScheduleRows: [],
  validScheduleRows: [],
  scheduleUploadError: null,
  scheduleUploadResult: []
}

export default (state = initialState, action) => {
  switch (action.type) {

  case RestaurantPoolScheduleActions.CSV_PARSE_STARTED:
    return {
      ...initialState,
      csvParseRaw: action.csvParseRaw
    }

  case RestaurantPoolScheduleActions.CSV_PARSE_COMPLETED:
    return {
      ...state,
      csvParseRaw: action.csvParseRaw,
      csvParseErrors: action.csvParseResult.errors || []
    }


  case RestaurantPoolScheduleActions.SCHEDULE_LOAD_STARTED:
    return {
      ...state,
      isLoading: true
    }

  case RestaurantPoolScheduleActions.SCHEDULE_LOAD_COMPLETED:
    
    const rows = new Map()

    // existing rows
    for(const row of state.scheduleRows){
      rows[row.id] = row
    }

    // insert/update existing with new rows
    for(const row of action.scheduleRows){
      rows[row.id] = row
    }

    //convert back to array
    const newRows = Object.keys(rows).map(key=>rows[key])

    return {
      ...state,
      isLoading: false,
      lastScheduleRowUpdate: new Date(),
      scheduleRows:newRows,
      invalidScheduleRows: newRows.filter(x=>!x.isRestaurantValid || !x.isPoolValid || !x.isStartDateUtcValid),
      validScheduleRows: newRows.filter(x=>x.isRestaurantValid && x.isPoolValid && x.isStartDateUtcValid),
    }
  case RestaurantPoolScheduleActions.SCHEDULE_LOAD_ERROR:
    return {
      ...state,
      scheduleError: action.scheduleError,
      isLoading: false
    }

  case RestaurantPoolScheduleActions.SCHEDULE_SUBMIT_STARTED:
    return {
      ...state,
      isLoading: true
    }

  case RestaurantPoolScheduleActions.SCHEDULE_SUBMIT_COMPLETED:
    return {
      ...state,
      isLoading: false,
      scheduleUploadResult: action.scheduleUploadResult
    }


  case RestaurantPoolScheduleActions.SCHEDULE_SUBMIT_ERROR:
    return {
      ...state,
      scheduleUploadError: action.scheduleUploadError,
      isLoading: false
    }

  default:
    return state
  }
}




// WEBPACK FOOTER //
// ./src/reducers/restaurantPoolSchedule.js